import React from 'react';
import gql from 'graphql-tag';
import { Query } from 'react-apollo';
import { curry, get } from 'lodash';

import CustomerWidgetContext from '../../CustomerWidgetContext';

export const CASE_WHEEL_PREFERENCES_NAME =
  'compositions_CustomersWidget_wheelPreferencesQuery';

const customerQuery = gql`
  query ${CASE_WHEEL_PREFERENCES_NAME} ($caseNumber: String!) {
    case (caseNumber: $caseNumber) {
      id
      customer(useCachedDataForCase: true) {
        ... on Customer {
          id
          billTo
          wheelPreferences { color comments diameter material offset type }
        }

        ... on StoreCustomer {
          id
          wheelPreferences { color comments diameter material offset type }
        }
      }
    }
  }
`;

const buildQueryChild = curry(
  (WrappedComponent, componentProps, queryProps) => {
    const wheels = (
      get(queryProps, 'data.case.customer.wheelPreferences') || []
    ).map((wheel, index) => ({ ...wheel, priority: index + 1 }));

    return <WrappedComponent {...componentProps} wheels={wheels} />;
  },
);

function buildWrappedComponentWithQuery(WrappedComponent, componentProps) {
  const { caseNumber, customerId } = componentProps;

  return (
    <Query
      query={customerQuery}
      skip={!caseNumber || !customerId}
      variables={{ caseNumber, customerId }}
    >
      {buildQueryChild(WrappedComponent, componentProps)}
    </Query>
  );
}

export const buildConsumerChild = curry(
  (WrappedComponent, componentProps, consumerProps) => {
    const { caseNumber } = consumerProps;

    return buildWrappedComponentWithQuery(WrappedComponent, {
      ...componentProps,
      caseNumber,
      customerId: get(componentProps, 'customer.id'),
    });
  },
);

const withWheelPreferences = WrappedComponent => componentProps => (
  <CustomerWidgetContext.Consumer>
    {buildConsumerChild(WrappedComponent, componentProps)}
  </CustomerWidgetContext.Consumer>
);

export default withWheelPreferences;



// WEBPACK FOOTER //
// ./src/compositions/CustomerWidget/CustomerDetails/WheelPreferences/withWheelPreferences.js